declare global {
	interface Window {
		umami: Umami
	}
}

type Umami = {
	track: typeof track
	identify: typeof identify
}

export function track(): void
export function track(payload: Record<string, unknown>): void
export function track(eventName: string): void
export function track(eventName: string, eventData: Record<string, unknown>): void
export function track(...args: Array<any>): void {
	if (typeof args[0] === 'string') args[1] = args[1] ?? {}
	return (window.umami?.track as any)?.(...args)
}

export function identify(uniqueId: string): void
export function identify(uniqueId: string, data: Record<string, unknown>): void
export function identify(data: Record<string, unknown>): void
export function identify(...args: Array<any>): void {
	return (window.umami?.identify as any)?.(...args)
}

export const umami = { track, identify }
